var _defs, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoTradetrust(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 428.82 167.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ef7d00;}.cls-2{fill:#2660a8;}.cls-3{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 57.86,
    y1: 94.03,
    x2: 82.19,
    y2: 118.38,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 170)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2660a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#3061a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#4a658a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#756b66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#af7436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef7d00"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 62.92,
    cy: 44.31,
    r: 5.75
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 35.37,
    cy: 70.92,
    r: 7.71
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 57.06,
    cy: 94.3,
    r: 7.71
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 79.53,
    cy: 43.96,
    r: 5.39
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 96.77,
    cy: 43.96,
    r: 5.39
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 79.53,
    cy: 83.68,
    r: 5.39
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 57.18,
    cy: 118.12,
    r: 7.82
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M84.61,61.32A5.43,5.43,0,0,0,78,58.17a5.36,5.36,0,0,0-3.67,4h0A3.58,3.58,0,0,1,73.2,64a11.06,11.06,0,0,1-10.51,1.23,14.41,14.41,0,0,1-1.86-.89,7.52,7.52,0,0,0-1-.46l-.19-.07a7.56,7.56,0,0,0-5.38,0,7.71,7.71,0,0,0,5.2,14.51,7.56,7.56,0,0,0,3.88-3,7.72,7.72,0,0,0,.59-1h0s4.9-8.19,11.13-7.24a4.45,4.45,0,0,1,1.46.73h0a5.33,5.33,0,0,0,4.74.67,5.39,5.39,0,0,0,3.46-6.81C84.69,61.53,84.65,61.42,84.61,61.32Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M98.58,84.44h30.54v7.83H117.91V126h-8.18V92.27H98.58Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M139.56,96.3v5.1A7.84,7.84,0,0,1,143,97.16a10.71,10.71,0,0,1,5.58-1.46v8.54a8.76,8.76,0,0,0-6.29,1.43c-1.81,1.22-2.72,3.26-2.72,6.1V126h-7.65V96.3Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M257.85,84.44h30.54v7.83H277.18V126H269V92.27H257.85Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M298.82,96.3v5.1a7.93,7.93,0,0,1,3.44-4.24,10.67,10.67,0,0,1,5.57-1.46v8.54a8.73,8.73,0,0,0-6.28,1.43c-1.82,1.22-2.73,3.26-2.73,6.1V126h-7.65V96.3Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M353.31,103.89q0,1.89,5.4,3.26a27.11,27.11,0,0,1,3.44,1,15,15,0,0,1,3.11,1.6,7.11,7.11,0,0,1,2.46,2.76,8.52,8.52,0,0,1,.89,4,8.21,8.21,0,0,1-3.44,7,14.29,14.29,0,0,1-8.48,2.44q-9.13,0-12.45-7.06l6.64-3.74c.91,2.57,2.85,3.85,5.81,3.86,2.73,0,4.1-.85,4.09-2.55,0-1.27-1.8-2.35-5.39-3.26-1.35-.36-2.49-.71-3.44-1.07a17.5,17.5,0,0,1-3.08-1.57,6.81,6.81,0,0,1-2.52-2.67,8,8,0,0,1-.86-3.82,8.19,8.19,0,0,1,3.2-6.88,12.65,12.65,0,0,1,8.06-2.55,13.38,13.38,0,0,1,6.58,1.63A12,12,0,0,1,368,101l-6.52,3.56a4.87,4.87,0,0,0-4.75-3,4.13,4.13,0,0,0-2.46.68A2.06,2.06,0,0,0,353.31,103.89Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M390.86,96v7.37h-6.72v12.37a2.94,2.94,0,0,0,.78,2.26,3.53,3.53,0,0,0,2.26.8,32.27,32.27,0,0,0,3.68,0v7q-7.78.9-11.09-1.46c-2.2-1.56-3.3-4.41-3.3-8.53V103.34H371.3V96h5.17V90l7.67-2.32V96Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M321,96.37v15.9c0,3.79,1.76,6.1,5.9,6.1s5.87-2.35,5.87-6.1V96.37h7.62v16a18.41,18.41,0,0,1-1,6.24,10.47,10.47,0,0,1-3.15,4.23,16,16,0,0,1-18.81,0,10.73,10.73,0,0,1-3.22-4.23,16.34,16.34,0,0,1-.91-6.24v-16Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M175.58,99V95.5h7.64v29.65h-7.64v-3.5a11.66,11.66,0,0,1-9.67,4.33,13.62,13.62,0,0,1-10.2-4.51,16.8,16.8,0,0,1,0-22.24,13.52,13.52,0,0,1,10.2-4.56Q172.14,94.64,175.58,99Zm-16.43,11.32a7.8,7.8,0,1,0,7.8-7.8,7.8,7.8,0,0,0-7.8,7.8Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M212.64,99V83.61h7.64v41.51h-7.64v-3.5q-3.39,4.32-9.61,4.33a13.68,13.68,0,0,1-10.26-4.51,16.8,16.8,0,0,1,0-22.24A13.58,13.58,0,0,1,203,94.64Q209.26,94.64,212.64,99Zm-16.43,11.32a7.8,7.8,0,1,0,7.8-7.8,7.8,7.8,0,0,0-7.8,7.8Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.72,113.4H232.3q1.48,5.58,8.38,5.59a7.82,7.82,0,0,0,6.66-3l6.19,3.57q-4.4,6.38-13,6.37-7.38,0-11.84-4.46a16.4,16.4,0,0,1-.06-22.42A15,15,0,0,1,240,94.55a14,14,0,0,1,10.76,4.52A15.61,15.61,0,0,1,255,110.25,20.72,20.72,0,0,1,254.72,113.4Zm-22.54-6h15.16a7.19,7.19,0,0,0-7.37-6,8.09,8.09,0,0,0-5.11,1.57,7.55,7.55,0,0,0-2.68,4.48Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTradetrust);
export default __webpack_public_path__ + "static/media/logo-tradetrust.7379555753a1d1bb99042af0a32134fc.svg";
export { ForwardRef as ReactComponent };